/* eslint-disable camelcase */
import React, { useEffect, useMemo, useState } from 'react';
import { Text, View } from '@applane/react-core-components';
import Toast from '@applane/react-toast';
import { ActivityIndicator } from '@applane/react-activity-indicator';
import moment from 'moment';
import { getUser, invoke, setUser } from '../../../AppServices';
import { Form } from '../../../app-components/form/Form';
import { ROUTES } from '../../../Lib/constants';
import vars from '../../../theme/vars';
import {
  avGenerationHistory,
  back_Icon,
  buyIcon,
  dealerSettingsLogo,
  editDealerLogo,
  loginAsThisDealer,
  manageDealerKycLogo,
  passwordIcon,
  subscriptionHistoryLogo,
  usedCarInventoryConversionReport,
} from '../../../images';
import { IconButton } from '../../../app-components/buttons/Buttons';
import { Storage } from '../../../app-components';
import { checkExpiry } from '../EditDealer';

const { headings } = vars;

const theme = {
  boundry: {
    // border: '1px solid red',

    // display: 'flex',
    flexDirection: 'row',
    justifyContent: 'between',
    alignItems: 'center',
  },

  titleBox: {
    width: '50%',
    // border: '1px solid black',
    paddingLeft: 5,
  },

  buttonsBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    // justifyContent: 'end',
    // width: '50%',
    paddingRight: 10,
  },
};

const handleEditDealerButton = (data = {}, navigation) => {
  const {
    setupState,
    paymentMode,
    kycStatus,
    paymentStatus,
    activityStatus,
    _id,
    username,
  } = data;

  if (kycStatus === 'Approved') {
    if (setupState === 'Pending') {
      Toast.show({
        message: 'Please Complete Setting Up Account First.',
        type: 'warning',
        position: 'top',
        direction: 'left',
      });
    } else if (paymentMode === 'N.A.') {
      Toast.show({
        message: 'Please Purchase Subscription Plan First.',
        type: 'warning',
        position: 'top',
        direction: 'left',
      });
    } else {
      navigation.navigate(ROUTES.editDealer.name, {
        item: {
          activityStatus,
          paymentMode,
          _id,
          paymentStatus,
          username,
        },
      });
    }
  } else {
    Toast.show({
      message: 'Please Approve KYC First',
      type: 'warning',
      position: 'top',
      direction: 'left',
    });
  }
};

const handleKycButton = (data = {}, navigation) => {
  const { setupState, kycStatus } = data;

  if (setupState === 'Pending') {
    if (kycStatus !== 'Approved') {
      navigation.navigate(ROUTES.editDealerKyc.name, {
        item: { _id: data._id, setupState },
      });
    } else {
      navigation.navigate(ROUTES.setupDealerAccount.name, {
        item: { _id: data._id, setupState },
      });
    }
  } else {
    navigation.navigate(ROUTES.editDealerKyc.name, {
      item: { _id: data._id, setupState },
    });
  }
};

const handleSettingButton = (data = {}, navigation) => {
  navigation.navigate(ROUTES.dealerSettingsBack.name, { item: { ...data } });
};

const handleBuyButton = (data = {}, navigation) => {
  const {
    setupState, paymentMode, kycStatus, expire,
  } = data;

  if (kycStatus === 'Approved') {
    if (setupState === 'Pending') {
      Toast.show({
        message: 'Please Complete Setting Up Account First.',
        type: 'warning',
        position: 'top',
        direction: 'left',
      });
    } else if (paymentMode === 'N.A.' || checkExpiry(expire) === 'Expired') {
      navigation.navigate(ROUTES.buyPlan.name, {
        item: { ...data },
      });
    } else {
      Toast.show({
        message: 'Plan Already Active',
        type: 'warning',
        position: 'top',
        direction: 'left',
      });
    }
  } else {
    Toast.show({
      message: 'Please Approve KYC First',
      type: 'warning',
      position: 'top',
      direction: 'left',
    });
  }
};

const handlePlanHistoryButton = (data = {}, navigation) => {
  navigation.navigate(ROUTES.subscriptionHistoryListAllBackButton.name, {
    item: { ...data },
  });
};

// eslint-disable-next-line no-unused-vars
const handleAppraisalHistoryButton = (data = {}, navigation) => {
  navigation.navigate(ROUTES.appraisalHistoryList.name, { item: { ...data } });
};

// eslint-disable-next-line no-unused-vars
const handleUCIReportButton = (data = {}, navigation) => {
  navigation.navigate(ROUTES.uciReportListWithBackButton.name, {
    item: { ...data },
  });
};
// these 2

const handleLoginButton = async (data = {}, navigation) => {
  const user = await getUser();

  const fromBackend = await invoke({
    id: 'loginAsThisDealer',
    paramValue: { item: { ...data } },
  });

  if (fromBackend.user.enforceChangePassword) {
    Toast.show({
      message: 'Account not Verified yet.',
      type: 'warning',
      direction: 'right',
      position: 'top',
    });
  } else {
    navigation.reset(ROUTES.WelcomeDealer.name);
    setUser(fromBackend.user);
    Storage.setItem('fromSuperDealer', user.username);
    Storage.setItem('refreshToken', fromBackend.refreshToken);
    Storage.setItem('tokenExpiryTime', fromBackend.tokenExpiryTime);
    Storage.setItem('token', fromBackend.token);
    Storage.setItem('fromSuperAdmin', true);
    window.location.reload();
  }
};

const handlePasswordButton = (data, navigation) => {
  // navigation.navigate(ROUTES.password.name, { ...data, type: 'dealer' },);
  navigation.push({
    view: ROUTES.password.name,
    params: {
      item: { ...data },
      type: 'dealer',
    },
    modal: true,
    modalProps: {
      backgroundColor: 'transparent',
    },
  });
};

const handleAppraisalResultGeneratedButton = (data, navigation) => {
  navigation.navigate('appraisal-result-list-avgen-back', {
    item: { ...data },
  });
};

const handleAppraisalResultCapturedButton = (data, navigation) => {
  navigation.navigate('appraisal-result-list-uci-back', { item: { ...data } });
};

const ViewDealer = (props) => {
  const { lastViewIndex, navigation } = props;
  const [data, setData] = useState({
    _id: '--',
    username: '--',
    phonenumber: '--',
    email: '--',
    kycStatus: '--',
    activityStatus: '--',
    expire: '--',
    paymentStatus: '--',
    planId: '--',
    paymentMode: '--',
    name: '--',
    setupState: '--',
  });

  const dealerId = useMemo(
    () => navigation?.state?.params?.item?._id,
    [navigation.state.params.item._id],
  );

  useEffect(() => {
    const fetchData = async () => {
      const { result } = await invoke({
        id: 'allDataOfDealer',
        paramValue: { dealerId },
      });
      setData(result);
    };

    fetchData();
  }, [dealerId, lastViewIndex]);

  return (
    <>
      <View style={theme.boundry} className='d-block d-md-flex justify-content-between mt-4'>
        <View style={theme.titleBox}>
          <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Details</Text>
          {/* {data?.username} Details */}
        </View>
        <View style={theme.buttonsBox} className='w-md-50 justify-content-md-end'>
          <IconButton
            tooltipId="login-as-this-dealer"
            description="Login As This Dealer"
            iconStyle={{ height: 20, width: 20 }}
            stylelg={{ paddingLeft: 0, paddingRight: 0 }}
            customStyle={{
              marginLeft: 10,
              marginRight: 10,
            }}
            label="Login as this Dealer"
            icon={loginAsThisDealer}
            labelStyle={{
              fontSize: 18,
              color: '#ffffff',
              fontFamily: 'Mulish-SemiBold',
            }}
            onClick={async () => {
              await handleLoginButton(data, navigation);
            }}
          />
          <IconButton
            tooltipId="appraisals-captured"
            style={{ usingIcon: true }}
            description="Appraisals Captured"
            icon={usedCarInventoryConversionReport}
            iconStyle={{ height: 20, width: 20 }}
            stylelg={{ paddingLeft: 0, paddingRight: 0 }}
            customStyle={{
              marginLeft: 10,
              marginRight: 10,
            }}
            labelStyle={{
              fontSize: 18,
              color: '#ffffff',
              fontFamily: 'Mulish-SemiBold',
            }}
            onClick={() => handleAppraisalResultCapturedButton(data, navigation)}
          />
          <IconButton
            tooltipId="appraisals-generated"
            style={{ usingIcon: true }}
            stylelg={{ paddingLeft: 0, paddingRight: 0 }}
            description="Appraisals Generated"
            icon={avGenerationHistory}
            iconStyle={{ height: 20, width: 20 }}
            customStyle={{
              marginLeft: 10,
              marginRight: 10,
            }}
            labelStyle={{
              fontSize: 18,
              color: '#ffffff',
              fontFamily: 'Mulish-SemiBold',
            }}
            onClick={() => {
              handleAppraisalResultGeneratedButton(data, navigation);
            }}
          />
          <IconButton
            tooltipId="dealer-setings"
            style={{ usingIcon: true }}
            iconStyle={{ height: 20, width: 20 }}
            description="Dealer Settings"
            icon={dealerSettingsLogo}
            stylelg={{ paddingLeft: 0, paddingRight: 0 }}
            customStyle={{
              marginLeft: 10,
              marginRight: 10,
            }}
            labelStyle={{
              fontSize: 18,
              color: '#ffffff',
              fontFamily: 'Mulish-SemiBold',
            }}
            onClick={() => {
              handleSettingButton(data, navigation);
            }}
          />
          {/* <IconButton
            description="Edit Dealer"
            tooltipId="edit-dealer"
            customStyle={{
              marginLeft: 10,
              marginRight: 10,
            }}
            style={{ usingIcon: true }}
            iconStyle={{ height: 20, width: 20 }}
            icon={editDealerLogo}
            stylelg={{ paddingLeft: 0, paddingRight: 0 }}
            onClick={() => handleEditDealerButton(data, navigation)}
          /> */}

          <IconButton
            description="Change Password"
            tooltipId="daler-password-change"
            icon={passwordIcon}
            label="Change Password"
            customStyle={{
              marginLeft: 10,
              marginRight: 10,
            }}
            labelStyle={{
              fontSize: 18,
              color: '#ffffff',
              fontFamily: 'Mulish-SemiBold',
            }}
            onClick={() => handlePasswordButton(data, navigation)}
          />
          <IconButton
            description="Back"
            tooltipId="go-back"
            customStyle={{
              marginLeft: 10,
              marginRight: 10,
            }}
            style={{ usingIcon: true }}
            imageStyle={{ width: 35, height: 35 }}
            icon={back_Icon}
            stylelg={{ paddingLeft: 0, paddingRight: 0 }}
            onClick={() => navigation.reset(ROUTES.superDealerData.name)}
          />
        </View>
      </View>
      {data?._id === '--' ? (
        <ActivityIndicator />
      ) : (
        <Form
          type="standard"
          fieldContainer="topLabel"
          lg={{
            formGroups: [
              {
                columnsPerRow: 2,
                fieldVariant: 'filled',
                groups: [
                  {
                    columns: [
                      {
                        label: 'Dealership Name',
                        render: () => (
                          <Text style={{ fontSize: 20 }}>{data?.name}</Text>
                        ),
                      },
                      {
                        label: 'Username',
                        render: () => (
                          <Text style={{ fontSize: 20 }}>{data?.username}</Text>
                        ),
                      },
                      {
                        label: 'Phone Number',
                        render: () => (
                          <Text style={{ fontSize: 20 }}>
                            {data?.phonenumber}
                          </Text>
                        ),
                      },
                      {
                        label: 'Email Id',
                        render: () => (
                          <Text style={{ fontSize: 20 }}>{data?.email}</Text>
                        ),
                      },
                    ],
                  },
                ],
              },
            ],
          }}
          {...props}
        />
      )}
    </>
  );
};

export default ViewDealer;
